<template>
  <div class="container mb-25">
    <div class="row justify-content-center">
      <div class="col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6">
        <div class="card card-prelogin border-0 rounded-0 bg-white authentication-card">
          <div class="card-body letter-spacing">
            <h4 class="fw-bold mb-0">
              {{ $t('feature.auth.$login.title') }}
            </h4>
            <form id="login-form" v-on:submit="submit">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  {{ $t('form.email.label') }}
                </label>
                <input type="email" title="Email" class="form-control shadow-none text-black" v-model="username"
                  :class="[{ 'is-invalid': submitted && !usernameIsValid }]" :placeholder="$t('form.email.placeholder')"
                  required pattern="[^@\s]+@[^@\s]+\.[^@\s]+" />
              </div>

              <!-- <div class="d-flex align-items-center justify-content-between mb-15 mb-md-20">
                <router-link to="/forgot-password"
                  class="forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative">
                  {{ $t('feature.auth.forgot_password') }}?
                </router-link>
                <router-link to="/request-support"
                  class="forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative">
                  {{ $t('feature.auth.request_support') }}
                </router-link>
              </div> -->
              <button class="default-btn transition fw-medium fs-md-15 fs-lg-16 d-block w-100" type="submit"
                v-on:click="setPristine" v-if="!loading">
                {{ $t('cta.login') }}
              </button>
              <SpinnerLoading v-else />
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- ERROR MESSAGE -->
    <div class="row justify-content-center">
      <div class="col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6">
        <div class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0"
          role="alert" id="errorMessage">
          <strong>{{ errorMessage }}</strong>
          <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import stateStore from "../../../utils/store";
import API from '../../../services/api/api.service';
import { Alert } from "bootstrap";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import OTPstore from "@/utils/otp.store";

export default defineComponent({
  name: "OTPLoginForm",
  components: {
    SpinnerLoading
  },
  data: () => {
    return {
      loading: false,
      username: '',
      password: '',
      submitted: false,
      errorMessage: '',
      errorAlert: undefined,
    } as {
      loading: boolean,
      username: string,
      password: string,
      submitted: boolean,
      errorAlert?: Alert,
      errorMessage?: string,
    }
  },
  mounted() {
    this.errorMessage = this.$t('error.something_went_wrong');
    this.errorAlert = new Alert('#errorMessage');
  },
  computed: {
    usernameIsValid() {
      var EMAIL_PATTERN = '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$';
      var EMAIL_REGEXP = new RegExp(EMAIL_PATTERN, 'i');
      return EMAIL_REGEXP.test(this.username);
    },
    passwordIsValid() {
      return this.password.length != 0;
    }
  },
  methods: {
    submit(e) {
      this.submitted = true;
      e?.preventDefault();
      this.login();
    },
    login() {
      this.loading = true;
      API.loginOTP(this.username).then((response) => {
        if(response.status === 200 && response.data.success === true) {
          OTPstore.storeLoginChallangeToken(response.data.challenge_token);
          this.$router.push('/login/verify');
        } else {
          this.showError(response.data?.message ?? this.$t('error.something_went_wrong'));
        }
      }).catch((error) => {
        this.showError(error);
      }).finally(() => {
        this.loading = false;
      });
    },
    setPristine() {
      this.submitted = true;
    },
    showError(error?: any) {
      if ('response' in error) {
        this.errorMessage = error.response?.data?.message ?? this.$t('error.something_went_wrong');
      } else {
        this.errorMessage = this.$t('error.connection_error');
      }
      const error_element = document.getElementById('errorMessage');
      error_element?.classList.add('show');
      setTimeout(() => {
        this.hideError();
      }, 5000)
    },
    hideError() {
      const error = document.getElementById('errorMessage');
      error?.classList.remove('show');
    }
  }
});
</script>